import React from "react"
import { Image } from "semantic-ui-react"
import ReactSVG from "react-svg"
import ShopDirectionLogo from "../../../images/shop-direction.svg"
import FuelShopLogo from "../../../images/fuel-shop.png"
import ShopListShimmer from "../../../v1/CarAdvise2/screens/dashboard/components/ShopListShimmer"
import { useTranslation } from "react-i18next"
import openInGoogleMaps from "../../../v1/helpers/mapBoxHelpers"
import { isEmpty } from "lodash"

const ShopList = ({ shops, isLoading }) => {
  const { t } = useTranslation("fuelStation")

  return (
    <div className={`shop-list  ${!isLoading && isEmpty(shops) ? "no-shops-found" : ""} `}>
      {!isLoading ? (
        !isEmpty(shops) ? (
          shops.map((shop) => (
            <div key={shop.id} className="shop-tile">
              <Image src={shop.logo_url} />
              <div className="shop-detail">
                <p className="shop-name">{shop.site_name}</p>
                <p className="shop-info">
                  {shop.street1} {shop.city} {shop.state} {shop.country}
                </p>
                <p className="shop-miles">
                  {shop.distance} {t("mi")}
                </p>
              </div>
              <ReactSVG
                onClick={() => openInGoogleMaps(shop.lat, shop.lng, shop.site_name)}
                className="cursor-pointer"
                src={ShopDirectionLogo}
              />
            </div>
          ))
        ) : (
          <p>{t("dashboardMapComponent:noShopFound")}</p>
        )
      ) : (
        <ShopListShimmer count={8} />
      )}
    </div>
  )
}

export default ShopList
